import changeLocalStyling from 'styling/api/changeLocalStyling';
import changeSurveyIsFavorite from 'api/surveyList/changeSurveyIsFavorite';

import getSurvey from './getSurvey';
import getSurveys from './surveyList/getSurveys';
import getSurveysNames from './surveyList/getSurveysNames';
import createSurvey from './surveyList/createSurvey';
import changeSurveyStatus from './surveyList/changeSurveyStatus';
import bulk from './bulk';
import removeSurvey from './surveyList/removeSurvey';
import cloneSurvey from './surveyList/cloneSurvey';
import getTimezoneOptions from './getTimezoneOptions';
import getAgent from '../domains/authorization/api/getAgent';
import changeName from './changeName';
import changeSurveySlug from './changeSurveySlug';
import setLandingVisibility from './setLandingVisibility';
import setThankYouVisibility from './setThankYouVisibility';
import saveBlockList from './saveBlockList';
import deleteBlock from './deleteBlock';
import updateSectionBlockOrder from './updateSectionBlockOrder';
import updateBlock from './updateBlock';
import deleteSection from './deleteSection';
import uploadImage, { cancelImageUpload } from './uploadImage';
import getImage from './getImage';
import getImages from './getImages';
import deleteImage from './deleteImage';
import changeSurveySetting from './changeSurveySetting';
import getPostSurveyLogic from './getPostSurveyLogic';
import addPostSurveyLogicRule from './addPostSurveyLogicRule';
import removePostSurveyLogicRule from './removePostSurveyLogicRule';
import updatePostSurveyLogicRule from './updatePostSurveyLogicRule';
import addHeaderImage from './addHeaderImage';
import updateHeaderImage from './updateHeaderImage';
import removeHeaderImage from './removeHeaderImage';
import toggleFullWidth from './toggleFullWidth';
import getTemplate from './getTemplate';
import useSurveyForTemplate from './useSurveyForTemplate';
import updateBlockBulk from './updateBlockBulk';

export default {
  saveBlockList,
  updateSectionBlockOrder,
  updateBlock,
  updateBlockBulk,
  getTemplate,
  getSurvey,
  getSurveys,
  getSurveysNames,
  createSurvey,
  changeSurveyStatus,
  changeSurveyIsFavorite,
  removeSurvey,
  cloneSurvey,
  getTimezoneOptions,
  bulk,
  getAgent,
  changeName,
  changeSurveySlug,
  setLandingVisibility,
  toggleFullWidth,
  setThankYouVisibility,
  deleteBlock,
  deleteSection,
  uploadImage,
  cancelImageUpload,
  getImage,
  getImages,
  deleteImage,
  changeSurveySetting,
  getPostSurveyLogic,
  addPostSurveyLogicRule,
  removePostSurveyLogicRule,
  updatePostSurveyLogicRule,
  addHeaderImage,
  updateHeaderImage,
  removeHeaderImage,
  useSurveyForTemplate,
  changeLocalStyling,
};
